import * as Yup from 'yup';

export const shiftAssignmentSchema = Yup.object().shape({
    employee_id: Yup.mixed()
        .required('Employee ID is required')
        .test('is-valid-id', 'Invalid Employee ID', val => {
            return typeof val === 'string' || typeof val === 'number';
        }),
    date: Yup.string()
        .required('Date is required')
        .matches(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format'),
    shift_id: Yup.number()
        .required('Shift ID is required'),


    color: Yup.string().nullable(),
    break_hours: Yup.number().nullable(),
});
